import { useCallback } from 'react';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List } from 'foundations-components/transitional/components/List';
import { ListViewIcon } from 'foundations-assets/icons/components/ListViewIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Flex } from 'foundations-components/components/Flex';
import { Button } from 'foundations-components/transitional/components/Button';
import { getBrochureRoot } from '../achievementQueries';
import { addUrlParams } from '../../../utils/RoutingUtils';
import { ACHubSpotLogo } from 'academy-navigation-lib/components/ACHubSpotLogo';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const buildUrl = (brochureRoot, path, cta) => addUrlParams(`${brochureRoot}${path}`, {
  'hubs_content-cta': cta
});
const NavLinks = ({
  links = [],
  trackEvent,
  language
}) => {
  const brochureRoot = getBrochureRoot(language);
  const trackClick = useCallback(({
    currentTarget
  }) => trackEvent({
    action: 'click-header-nav-button',
    href: currentTarget.href,
    isExternalLink: true,
    isResponsive: JSON.parse(currentTarget.dataset.isResponsive)
  }), [trackEvent]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: links.map(([label, cta, path]) => /*#__PURE__*/_jsx(Button, {
      "data-is-responsive": false,
      href: buildUrl(brochureRoot, path, cta),
      marginInlineStart: "0",
      onClick: trackClick,
      use: "transparent",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `learningCenter.certification.heading.nav.${label}`
      })
    }, `${label}${path}`))
  });
};
const linksPropDefault = [['courses', 'achievement-cta-courses', '/courses'], ['certifications', 'achievement-cta-certifications', '/certification-overview'], ['aboutAcademy', 'achievement-cta-about-academy', '/what-is-hubspot-academy']];
const NavMenu = ({
  inModal,
  links = linksPropDefault,
  trackEvent,
  language
}) => {
  const {
    isLaptop
  } = useMediaQuery();
  return /*#__PURE__*/_jsxs("div", {
    children: [!isLaptop && /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(NavLinks, {
        language: language,
        links: links,
        trackEvent: trackEvent
      })
    }), isLaptop && !inModal && /*#__PURE__*/_jsx(View, {
      children: /*#__PURE__*/_jsx(Dropdown, {
        buttonText: /*#__PURE__*/_jsx(ListViewIcon, {
          color: "icon-core-default",
          size: "600"
        }),
        buttonUse: "unstyled",
        caretRenderer: null,
        placement: "bottom left",
        popoverProps: {
          arrowSize: 'small'
        },
        children: /*#__PURE__*/_jsx(List, {
          wrapChildren: true,
          children: /*#__PURE__*/_jsx(NavLinks, {
            language: language,
            links: links,
            trackEvent: trackEvent
          })
        })
      })
    })]
  });
};
const CertificateHeader = ({
  inModal,
  trackEvent,
  language
}) => {
  const {
    isTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsx("header", {
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "row",
      flexWrap: "nowrap",
      justifyContent: "space-between",
      paddingBlockEnd: "200",
      paddingBlockStart: "300",
      children: [/*#__PURE__*/_jsx(Flex, {
        alignItems: isTablet ? 'start' : 'center',
        flexDirection: isTablet ? 'column' : 'row',
        flexShrink: 0,
        children: /*#__PURE__*/_jsx(ACHubSpotLogo, {})
      }), /*#__PURE__*/_jsx(NavMenu, {
        inModal: inModal,
        language: language,
        trackEvent: trackEvent
      })]
    })
  });
};
export default CertificateHeader;